import type { UsageTimeseriesBucket } from './useUsageData';

/**
 * Compute billing period [start, end) for a given monthStartDay and offset.
 * offset=0 is the current period, -1 is the previous, etc.
 * Date.UTC handles month overflow/underflow automatically.
 */
export function computeBillingPeriod(
  monthStartDay: number,
  offset: number,
  now = new Date(),
): { start: Date; end: Date } {
  const year = now.getUTCFullYear();
  const month = now.getUTCMonth();
  const day = now.getUTCDate();

  const periodMonth = (day >= monthStartDay ? month : month - 1) + offset;
  const start = new Date(Date.UTC(year, periodMonth, monthStartDay));
  const end = new Date(Date.UTC(year, periodMonth + 1, monthStartDay));
  return { start, end };
}

/**
 * Transform daily timeseries buckets into cumulative agentic run data.
 * Agentic runs (≥1 agent step) are the metric the monthly quota counts,
 * so the billing-period chart must cumulate the same series.
 */
export function buildCumulativeData(
  buckets: UsageTimeseriesBucket[],
): { day: string; cumulative: number }[] {
  let cumulative = 0;
  return buckets.map((b) => {
    cumulative += b.agenticRuns;
    const d = new Date(b.bucket);
    return {
      day: d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' }),
      cumulative,
    };
  });
}
